<template>
  <div>
    <yd-cell-group>

      <yd-cell-item>
        <span slot="left" v-html="info"></span>
      </yd-cell-item>

      <yd-cell-item>
        <span slot="left">汇款银行：</span>
        <input slot="right" type="text" v-model="bank" placeholder="请填写汇款银行">
      </yd-cell-item>

      <yd-cell-item>
        <span slot="left">汇款账号：</span>
        <input slot="right" type="text" v-model="bankcount" placeholder="请填写汇款账号">
      </yd-cell-item>

      <yd-cell-item>
        <span slot="left">汇款方名称<span style="color: red">*</span>：</span>
        <input slot="right" type="text" v-model="remitname" placeholder="请填写汇款方名称">
      </yd-cell-item>

      <yd-cell-item class="upload">
        <span slot="left">上传汇款单：</span>
        <span slot="right" @change='thumb' type="file" style="position: relative;">
          <img v-show="!imgs" src="../../assets/image/upload.png" alt="" style="width: 1.4rem;height: 1.4rem;z-index: 1;">
          <img v-show="imgs" :src="imgs" style="width: 1.4rem;height: 1.4rem;z-index: 10;">
          <input style="z-index: 1000;opacity: 0;width: 100%;height: 1.4rem;line-height: 1.4rem;overflow:hidden;position: absolute;top: 50%;left: 0;transform: translate(0,-50%);" slot="right"
                  @change='thumb' type="file">
        </span>

      </yd-cell-item>
    </yd-cell-group>
    <div style="background-color: #fff;">

    </div>
    <div class="submit_div">
      <yd-button type="primary" @click.native="singleMy" v-preventReClick style="width: 1rem;background-color: transparent!important;border: solid 1px #c82921;color: #c82921;">后续上传</yd-button>
      <yd-button type="danger" @click.native="submitTransfer" v-preventReClick style="background-color: #c82921;width: 1rem;">提交</yd-button>
    </div>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'

export default {
  data () {
    return {
      params: this.$route.params,
      info: '',
      imgs: '',
      bank: '',
      remitname: '',
      bankcount: '',
      imgData: {
        accept: 'image/gif, image/jpeg, image/png, image/jpg'
      }
    }
  },
  methods: {
    getSetting (isHotel) {
      let type_ = 'zhifufangshi_setting'
      if (isHotel) {
        type_ = 'jdzhifufangshi_setting'
      }
      let data = {orderid: this.params.order_id, type_: type_}
      axios
        .post('/user/setting', data)
        .then(this.getSettingSucc)
    },
    getSettingSucc (res) {
      res = res.data
      if (res.status) {
        this.info = res.res
      }
    },
    HistoryBack () {
      window.history.back()
    },
    thumb (event) {
      let reader = new FileReader()
      let img1 = event.target.files[0]
      let type = img1.type // 文件的类型，判断是否是图片
      let size = img1.size // 文件的大小，判断图片的大小
      if (this.imgData.accept.indexOf(type) === -1) {
        alert('请选择我们支持的图片格式！')
        return false
      }
      // 图片的大小
      if (size > 3145728) {
        alert('请选择3M以内的图片！')
        return false
      }
      reader.readAsDataURL(img1)
      var that = this
      reader.onloadend = function (e) {
        that.imgs = e.target.result
      }
    },
    submitTransfer () {
      let res = this.checkTransfer()
      if (res) {
        return false
      }
      let data = {
        bank: this.bank,
        bankcount: this.bankcount,
        remitname: this.remitname,
        thumb: this.imgs,
        orderid: this.params.order_id
      }
      this.$dialog.loading.open()
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/fair/remit', data)
        .then(res => {
          res = res.data
          if (res.status === 1) {
            this.$dialog.loading.close()
            this.$dialog.toast({mes: res.msg})
            this.$router.push({path: '/' + this.params.id + '/single-my'})
          } else {
            this.$dialog.toast({mes: res.msg})
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    singleMy () {
      this.$router.push({path: '/' + this.params.id + '/single-my'})
    },
    checkTransfer () {
      if (this.remitname === '') {
        this.$dialog.toast({mes: '汇款方名称不能为空'})
        return true
      }
      if (this.imgs === '') {
        this.$dialog.toast({mes: '汇款凭证不能为空'})
        return true
      }
      return false
    },
    checkOrder () {
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('fair/order-cont', {id: this.params.order_id})
        .then(res => {
          res = res.data
          if (res.data.order.product_type === 29) {
            this.getSetting(1)
          } else {
            this.getSetting()
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    checkLogin () {
      if (!this.$store.state.uid) {
        this.$router.push({path: '/' + this.params.id + '/single-my'})
      }
    }
  },
  mounted () {
    this.checkLogin()
    this.checkOrder()
  }
}
</script>

<style lang="stylus" scoped>
  .submit_div
    text-align center
    padding-top .1rem
  .upload
    padding .24rem 0
    padding-left .24rem
  .upload>:last-child
    justify-content flex-start
    padding-left .4rem
</style>



// WEBPACK FOOTER //
// src/views/template1/BankTransfer.vue